'use client';
import { Loading as LoadingComponent } from '../../../components/Loading';

export default function Loading() {
  return <LoadingComponent />;
}
